import { Season } from 'app/frontend/types/custom'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'
import Card from './Card'
dayjs.extend(RelativeTime)

interface Props {
  run: { dungeon: number; level: number; key: string }
  dungeon?: Season['keystone_dungeons'][number]
}

const KeystoneRunCard = ({ run, dungeon }: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger className='flex items-center justify-center'>
        <Card className='flex min-w-[4.2rem] p-0'>
          <img
            className='h-8 w-8 object-cover rounded-l-md border-r'
            src={`https://render.worldofwarcraft.com/eu/zones/${dungeon?.background}-small.jpg`}
          />
          <span className='flex items-center text-base px-2'>{run.level}</span>
        </Card>
      </TooltipTrigger>
      <TooltipContent className='flex flex-col gap-0.5'>
        {dungeon?.name}
        <span className='text-xs text-muted-foreground'>
          {dayjs.unix(Number(run.key)).fromNow()}, at{' '}
          {dayjs.unix(Number(run.key)).format('HH:mm')}
        </span>
      </TooltipContent>
    </Tooltip>
  )
}

export default KeystoneRunCard
